import isEmpty from "lodash/isEmpty";
import { ShippingContextDataFn } from "../../instantAnswerDataFunctions/shippingContextDataFn";
export var ShippingCostEstimatesIA = function ShippingCostEstimatesIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    additionalRequiredData: [ShippingContextDataFn]
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var shippingContext = context.shippingContext;
  if (!shippingContext || isEmpty(shippingContext.shipments)) {
    return ORDER_NOT_SHIPPED(strictLocalize);
  }
  return shippingContext.estimated_shipping_cost ? ESTIMATES_INCLUDED_IN_ORDER_SHIPPED(strictLocalize) : ESTIMATES_NOT_INCLUDED_IN_ORDER_SHIPPED(strictLocalize);
};
var ORDER_NOT_SHIPPED = function ORDER_NOT_SHIPPED(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHAT_ARE_SHIPPING_ESTIMATES(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ESTIMATED_SHIPPING_COST_PROVIDED_AT_CHECKOUT_IF_AVAILABLE(strictLocalize)];
    }
  };
};
var ESTIMATES_INCLUDED_IN_ORDER_SHIPPED = function ESTIMATES_INCLUDED_IN_ORDER_SHIPPED(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHAT_ARE_SHIPPING_ESTIMATES(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ESTIMATED_SHIPPING_COST_PROVIDED_AT_CHECKOUT(strictLocalize)];
    }
  };
};
var ESTIMATES_NOT_INCLUDED_IN_ORDER_SHIPPED = function ESTIMATES_NOT_INCLUDED_IN_ORDER_SHIPPED(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return SHIPPING_COST_FINALIZED(strictLocalize);
    },
    getDescription: function getDescription() {
      return [SHIPPING_COST_FINALIZED_AFTER_ORDER_IS_SHIPPED(strictLocalize)];
    }
  };
};
var WHAT_ARE_SHIPPING_ESTIMATES = function WHAT_ARE_SHIPPING_ESTIMATES(strictLocalize) {
  return strictLocalize({
    id: "bPZOAl",
    defaultMessage: [{
      "type": 0,
      "value": "Wat zijn de geschatte verzendkosten?"
    }]
  });
};
var ESTIMATED_SHIPPING_COST_PROVIDED_AT_CHECKOUT_IF_AVAILABLE = function ESTIMATED_SHIPPING_COST_PROVIDED_AT_CHECKOUT_IF_AVAILABLE(strictLocalize) {
  return strictLocalize({
    id: "rbIhna",
    defaultMessage: [{
      "type": 0,
      "value": "Indien beschikbaar, geven we schatting van de verzendkosten bij het afrekenen. De uiteindelijke verzendkosten worden definitief vastgesteld nadat je bestelling is verzonden en zijn zichtbaar op je factuur."
    }]
  });
};
var ESTIMATED_SHIPPING_COST_PROVIDED_AT_CHECKOUT = function ESTIMATED_SHIPPING_COST_PROVIDED_AT_CHECKOUT(strictLocalize) {
  return strictLocalize({
    id: "KJ/T98",
    defaultMessage: [{
      "type": 0,
      "value": "Bij het afrekenen hebben we geschatte verzendkosten opgegeven. De uiteindelijke verzendkosten worden definitief vastgesteld nadat je bestelling is verzonden en zijn zichtbaar op je factuur."
    }]
  });
};
var SHIPPING_COST_FINALIZED = function SHIPPING_COST_FINALIZED(strictLocalize) {
  return strictLocalize({
    id: "/9nEPF",
    defaultMessage: [{
      "type": 0,
      "value": "Je verzendkosten zijn definitief vastgesteld"
    }]
  });
};
var SHIPPING_COST_FINALIZED_AFTER_ORDER_IS_SHIPPED = function SHIPPING_COST_FINALIZED_AFTER_ORDER_IS_SHIPPED(strictLocalize) {
  return strictLocalize({
    id: "T7qzRM",
    defaultMessage: [{
      "type": 0,
      "value": "De uiteindelijke verzendkosten worden definitief vastgesteld nadat je bestelling is verzonden en zijn zichtbaar op je factuur."
    }]
  });
};